import { Modal, Box, LinearProgress, Typography } from '@material-ui/core';

const ExportProgressModal = ({ open, progress }) => (
    <Modal open={open} aria-labelledby="export-progress-modal">
        <Box
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
                textAlign: 'center',
            }}
        >
            <Typography id="modal-title" variant="h6" component="h2">
                Exporting Data...
            </Typography>
            <LinearProgress
                variant="determinate"
                value={progress}
                sx={{ mt: 2 }}
            />
            <Typography variant="body2" sx={{ mt: 2 }}>
                {`Fetching data: ${progress?.toFixed(0)}%`}
            </Typography>
        </Box>
    </Modal>
);

export default ExportProgressModal;